// extracted by mini-css-extract-plugin
export default {"flexChild":"VendingDetail_flexChild__ID0dO","table":"VendingDetail_table__IsiZV"};